import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const COLORS = { activated: "#3B82F6", migrated: "#F43F5E", rate: "#F59E0B" };
export const fmtRate = (r) => (r == null ? "—" : `${String(r).replace(".", ",")}%`);
export const rateTone = (r) => (r == null ? "text-muted-foreground" : r >= 20 ? "text-red-400" : r >= 10 ? "text-amber-400" : "text-teal-400");
export const todayIso = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };
export const fmtDay = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

export const useSimSummary = (enabled) => {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    if (enabled) { api.get("/sim-stats/summary").then((r) => setSummary(r.data)).catch(() => {}); }
  }, [enabled]);
  return summary;
};
